import { useMediaQuery, DialogTitle, DialogContent, DialogActions, Grid2 as Grid, Dialog, Typography } from "@mui/material";
import { LargeActionButton } from "../Common/LargeActionButton";
import modalSize from "../../util/modalSizeEnum";
import { useStyles } from "./Modal.styles";
import { Alert, AlertTitle, AlertColor } from "@mui/material"; 
import { LargeActionLink } from "../Common/LargeActionLink";
import {
	compactSecondaryModalActionStyles,
	fullScreenSecondaryModalActionStyles,
	primaryModalActionStyles,
	secondaryModalActionStyles,
} from "../Common/modalActionStyles";
import { MOBILE_MODAL_MEDIA_QUERY } from "./Modal.constants";

interface ModalBaseProps {
	children?: React.ReactNode;
	isOpen: boolean;
	onClose?: () => void;
	title?: string;
	message?: string;
	primaryButtonName: string;
	primaryOutlinedButtonName?: string;
	secondaryButtonName?: string;
	onPrimaryButtonClick: () => void;
	onPrimaryOutlinedButtonClick?: () => void;
	onSecondaryButtonClick?: () => void;
	isPrimaryButtonDisabled?: boolean;
	alertType?: string;
	size?: string;
}

export const ModalBase = (props: ModalBaseProps) => {
	const classes = useStyles();
	const {
		isOpen,
		onClose: onCancel,
		title,
		message,
		children,
		primaryButtonName,
		primaryOutlinedButtonName,
		secondaryButtonName,
		onPrimaryButtonClick,
		onPrimaryOutlinedButtonClick,
		onSecondaryButtonClick,
		isPrimaryButtonDisabled,
		alertType,
		size,
	} = props;
	const mobileView = useMediaQuery(MOBILE_MODAL_MEDIA_QUERY);
	const secondaryActionStyles = mobileView
		? fullScreenSecondaryModalActionStyles
		: size === modalSize.FULLSCREEN
			? secondaryModalActionStyles
			: compactSecondaryModalActionStyles;
	const getAlertType = (alertType): AlertColor => {
		return alertType as AlertColor;
	};

	return (
		<Dialog
			open={isOpen}
			onClose={onCancel}
			className={size === modalSize.MEDIUM ? classes.modalBaseMediumSize : classes.fullScreen}
			fullScreen={mobileView}
		>
			<DialogTitle>
				<Alert
					severity={getAlertType(alertType)}
					variant="outlined"
					className={classes.modalBaseAlert}
					onClose={onCancel}
				>
					{title && <AlertTitle className={classes.alertTitle}>{title}</AlertTitle>}
				</Alert>
			</DialogTitle>
			<DialogContent className={classes.modalBaseDialogContent}>
				<Grid container className={classes.modalContent}>
					<Typography variant="body1">{message}</Typography>
				</Grid>
				{children}
			</DialogContent>
			<DialogActions className={classes.modalBaseDialogActions}>
				<Grid container direction="column" spacing={mobileView ? 1 : 1} sx={{ width: '100%' }}>
					<Grid size={12} container justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
						<LargeActionButton
							onClick={onPrimaryButtonClick}
							disabled={isPrimaryButtonDisabled}
							sx={primaryModalActionStyles}
							children={primaryButtonName}
						/>
					</Grid>
					{primaryOutlinedButtonName && (
						<Grid size={12} container justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
							<LargeActionButton
								variant="outlined"
								onClick={onPrimaryOutlinedButtonClick ?? (() => {})}
								sx={primaryModalActionStyles}
								children={primaryOutlinedButtonName}
							/>
						</Grid>
					)}
					{secondaryButtonName && (
						<Grid size={12} container justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
							<LargeActionLink
								onClick={onSecondaryButtonClick ?? (() => {})}
								sx={secondaryActionStyles}
								children={secondaryButtonName}
							/>
						</Grid>
					)}
				</Grid>
			</DialogActions>
		</Dialog>
	);
};
